type Props = {
  className?: string
}

export default function IconLoading({ className }: Props) {
  return (
    <svg
      xmlns="http://www.w3.org/2000/svg"
      width="16"
      height="16"
      viewBox="0 0 16 16"
      fill="none"
      className={className}>
      <circle cx="8" cy="8" r="7" stroke="#48128D" strokeWidth="1"></circle>
      <circle
        cx="8"
        cy="8"
        r="7"
        stroke="white"
        strokeWidth="1"
        strokeDasharray="32.98672286269283 87.96459430051421"
        strokeLinecap="square">
        <animateTransform
          attributeName="transform"
          type="rotate"
          from="0 8 8"
          to="360 8 8"
          dur="1s"
          repeatCount="indefinite"
        />
      </circle>
    </svg>
  )
}
